// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___3TYqg","empty":"styles__empty___bHma8","attach":"styles__attach___1_koO"};